import axiosInstance from './AxiosInstance';
import { store } from '../store/store';

export function getAllOrders() {
    return axiosInstance.get(`vendor/orders?type=all`);
}

// export function createOrder(order) {
//     console.log(order);
//     const state = store.getState();
//     // order.created_by = state.auth.auth.user.id;
//     const formData = new FormData();
//     formData.append("name", order.name);
//     formData.append("image", order.image);
//     formData.append("status", order.status);
//     formData.append("created_by", state.auth.auth.user.id);
//     const postData = {
//         ...order
//     };
//     return axiosInstance.post("admin/orders", formData,);
// }


// export function updateOrder(order,id) {
//     console.log(order);
//     const state = store.getState();
//     // order.created_by = state.auth.auth.user.id;
//     const formData = new FormData();
//     formData.append("name", order.name);
//     formData.append("image", order.image);
//     formData.append("status", order.status);
//     formData.append("created_by", state.auth.auth.user.id);
//     const postData = {
//         ...order
//     };
//     return axiosInstance.put("admin/orders?id="+id, formData,);
// }


export function getSelectedOrder(id) {
    return axiosInstance.get(`vendor/orders/show/`+id);
}




// export function changeStatusOrder(order,id) {
//     console.log(order);
//     const state = store.getState();
//     order.created_by = state.auth.auth.user.id;
//     const postData = {
//         ...order
//     };
//     return axiosInstance.put("admin/orders/status?id="+id, postData,);
// }
// export function deleteOrder(id) {
//     return axiosInstance.delete(`admin/orders?id=`+id);
// }